var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.$route.name === 'preference-table' ||
      _vm.$route.name === 'my-dashboard-details' ||
      _vm.$route.name === 'data-table' ||
      _vm.$route.name === 'sections'
    )?_c('div',[_c('stepper')],1):_vm._e(),_c('router-view',{staticClass:"mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }